import React from 'react';

import { Box, VStack, HStack } from '@frontend/components';

type HelpMessageProps = React.PropsWithChildren<{
  title: React.ReactNode;
}>;

export const HelpMessage = ({ title, children }: HelpMessageProps) => {
  return (
    <VStack align="start" gap={0.5}>
      {title}
      <HStack align="start" gap={1}>
        <Box minWidth="3px" minHeight="100%" bgColor="brand.secondary" />
        {children}
      </HStack>
    </VStack>
  );
};
